const Empty2 = () => {
    return (
        <div className="w-4/5 h-48 py-10 mx-auto justify-center">
            <h4 className="text-xl capitalize text-white mb-4">1.Here is no collection, and  you can purchase some NFTs to start collecting.</h4>
            <br />
            <h4 className="text-xl capitalize text-white mb-4">2.Click on the "Public Market" section, there is an option to "Create NFT".</h4>
            <br />
            <h4 className="text-xl capitalize text-white mb-4">3.Feel free to unleash your creativity and create your own artwork!</h4>
        </div>
    )
}

export default Empty2












